import React from 'react'
import { Link } from "react-router-dom";
import "../App.css"
import axios from "axios";
import Path from "./config";
class NavFormProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sbg_personal: true,
            sbg_edu: false,
            sbg_income: '',
            sbg_family: '',
            sbg_relative: '',
            sbg_asset: '',
            sbg_upload: '',
            sbg_post_address: '',
            admin: '',
            adminid: '',
            sbg_app_nondani: '',
            sbg_fulladdress_status: ''

        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("adminid")
        })

        //console.log (localStorage.getItem("adminid"));

        axios.get(Path + 'Suchi_bride_groom_navselect.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {

                // console.log("data",response.data);
                response = response.data;

                this.setState({

                    sbg_personal: response.sbg_personal,
                    sbg_edu: response.sbg_edu,
                    sbg_income: response.sbg_income,
                    sbg_family: response.sbg_family,
                    sbg_relative: response.sbg_relative,
                    sbg_asset: response.sbg_asset,
                    sbg_upload: response.sbg_upload,
                    sbg_post_address: response.sbg_post_address,
                    sbg_summery: response.sbg_summery,
                    sbg_app_nondani: response.sbg_app_nondani,
                    sbg_fulladdress_status: response.sbg_fulladdress_status
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }
    render() {
        let sbg_edu1 = "";

        if (this.state.sbg_edu === "1") {
            sbg_edu1 = <Link to={`/FormProfile/EducationInfo`} className="btn btn-primary active selectmenu" >शिक्षण  </Link>
        }
        else {

            sbg_edu1 = <span className="btn btn-light active selectmenu" >शिक्षण  </span>
        }

        let sbg_income1 = "";
        if (this.state.sbg_income === "1") {
            sbg_income1 = <Link to={`/FormProfile/IncomeInfo`} className="btn btn-primary active selectmenu" >उत्पन्न विषयीची माहिती  </Link>

        }
        else {

            sbg_income1 = <span className="btn btn-light active selectmenu" >उत्पन्न विषयीची माहिती  </span>

        }

        let sbg_family1 = "";
        if (this.state.sbg_family === "1") {
            sbg_family1 = <Link to={`/FormProfile/FamilyInfo`} className="btn btn-primary active" >कौटुंबिक माहिती  </Link>
        }
        else {

            sbg_family1 = <span className="btn btn-light active" >कौटुंबिक माहिती  </span>
        }

        let sbg_relative1 = "";
        if (this.state.sbg_relative === "1") {
            sbg_relative1 = <Link to={`/FormProfile/ContactInfo/`} className="btn btn-primary active" >संपर्कासाठीची नावे </Link>
        }
        else {

            sbg_relative1 = <span className="btn btn-light active" >संपर्कासाठीची नावे </span>
        }

        let sbg_asset1 = "";
        if (this.state.sbg_asset === "1") {
            sbg_asset1 = <Link to={`/FormProfile/AssetInfo`} className="btn btn-primary active" >स्थावर मालमत्ता </Link>
        }
        else {

            sbg_asset1 = <span className="btn btn-light active" >स्थावर मालमत्ता </span>
        }

        let sbg_upload1 = "";
        if (this.state.sbg_upload === "1") {
            sbg_upload1 = <Link to={`/FormProfile/UploadDoc`} className="btn btn-primary active" >अपलोड  </Link>
        }
        else {

            sbg_upload1 = <span className="btn btn-light active" >अपलोड  </span>
        }

        let sbg_post_address1 = "";
        if (this.state.sbg_post_address === "1") {
            sbg_post_address1 = <Link to={`/FormProfile/PostAddress`} className="btn btn-primary active" > सूची वाटप केंद्र  </Link>
        }
        else {

            sbg_post_address1 = <span className="btn btn-light active" > सूची वाटप केंद्र  </span>
        }

        let sbg_fulladdress_status1 = "";
        if (this.state.sbg_fulladdress_status === "1") {
            sbg_fulladdress_status1 = <Link to={`/FormProfile/PAddress`} className="btn btn-primary active" > पत्ता  </Link>
        }
        else {

            sbg_fulladdress_status1 = <span className="btn btn-light active" > पत्ता  </span>
        }

        let sbg_new = "";
        if (this.state.sbg_app_nondani === "1") {
            sbg_new =
                <Link to={`/FormProfile/Nondani`} className="btn btn-primary active" >अँप नोंदणी   </Link>
        }
        else {

            sbg_new = <span className="btn btn-light active" > अँप नोंदणी   </span>
            //  <Link to={ `/FormProfile/Nondani`} className="btn btn-primary active" >अँप नोंदणी   </Link>
        }



        let sbg_summery1 = "";
        if (this.state.sbg_summery === "1") {

            sbg_summery1 =
                <Link to={`/FormProfile/Fullbiodata`} className="btn btn-primary active" >परिचयपत्र  </Link>

        }
        else {

            sbg_summery1 = <span className="btn btn-light active" >परिचयपत्र </span>
        }



        return (
            <>

                <div className="btn-group">

                    <Link to={`/FormProfile`} ><button className="btn btn-primary active selectmenu "   >वैयक्तिक माहिती </button></Link>
                    {sbg_edu1}
                    {sbg_income1}
                    {sbg_family1}
                    {sbg_relative1}
                    {sbg_asset1}
                    {sbg_upload1}
                    {sbg_post_address1}
                    {sbg_fulladdress_status1}
                    {sbg_new}
                    {/* <Link to={ `/FormProfile/Nondani`} className="btn btn-primary active" >अँप नोंदणी   </Link> */}
                    {sbg_summery1}
                </div>

                {/* <div className="btn-group">
                <Link to="/FormProfile" ><button className="btn btn-primary active selectmenu "   >वैयक्तिक माहिती </button></Link>
                <Link to="/FormProfile/EducationInfo" className="btn btn-primary active selectmenu" >शिक्षण  </Link>
                <Link to="/FormProfile/IncomeInfo" className="btn btn-primary active selectmenu" >उत्पन्न विषयीची माहिती  </Link>
                <Link to="/FormProfile/FamilyInfo" className="btn btn-primary active" >कौटुंबिक माहिती  </Link>
                <Link to="/FormProfile/ContactInfo/:sbgr_id" className="btn btn-primary active" >संपर्कासाठीची नावे </Link>
                <Link to="/FormProfile/AssetInfo" className="btn btn-primary active" >स्थावर मालमत्ता </Link>
                <Link to="/FormProfile/UploadDoc" className="btn btn-primary active" >अपलोड  </Link>
                <Link to="/FormProfile/PostAddress" className="btn btn-primary active" >Post Address  </Link>
                <Link to="/FormProfile/All_record_summary" className="btn btn-primary active" >फॉर्म सारांश </Link>
            </div> */}


            </>
        )
    }
}

export default NavFormProfile
